import { render, staticRenderFns } from "./TextColumns.vue?vue&type=template&id=742a41d2&scoped=true"
import script from "./TextColumns.vue?vue&type=script&lang=js"
export * from "./TextColumns.vue?vue&type=script&lang=js"
import style0 from "./TextColumns.vue?vue&type=style&index=0&id=742a41d2&prod&lang=scss&scoped=true"
import style1 from "./TextColumns.vue?vue&type=style&index=1&id=742a41d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742a41d2",
  null
  
)

export default component.exports